import { normalizeTicketType } from "./mapper";

export const createTicketValidator = (data) => {
  const { firstCategory } = normalizeTicketType(data.type);

  if (!data.title || !data.type || !data.description) return false;
  if (isTicketMustIncludedOrderId(firstCategory) && !data.orderIds) return false;

  return true;
};

export const isTicketMustIncludedOrderId = (firstCategory) => {
  if (
    firstCategory === "Penjemputan/ Pengiriman" ||
    firstCategory === "Cash On Delivery (COD)" ||
    firstCategory === "Retur" ||
    firstCategory === "Klaim Paket Hilang/ Rusak"
  )
    return true;

  return false;
};
